import React, { Component } from 'react'
import { CancelCustomWager as CancelCustomWagerApi } from '../../../api-calls/customWagers'
import { cancelCustomWager as CancelCustomWagerContract } from '../../../contract/CancelController'
import { Popconfirm, message } from 'antd'
import { observer } from "mobx-react"

@observer(["AuthStore", "UserStore"])
export default class CancelCustomWager extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
        this.CancelCustomWager = this.CancelCustomWager.bind(this);
    }

    CancelCustomWager() {
        const { AuthStore, UserStore } = this.props;
        let bytes32Id = this.props.wager.bytes32Id;
        let wagerId = this.props.wager._id;
        let userId = UserStore.user._id;
        let authToken = AuthStore.userAuth.auth.accessToken;
        //console.log("Cancelling bet " + this.props.wager.bytes32Id);
        CancelCustomWagerContract(bytes32Id).then(
            function (result) {
                if (String(result).includes('User denied transaction signature')) {
                    message.warning("Metamask transaction denied! Bet not cancelled.");
                } else {
                    return CancelCustomWagerApi(
                        authToken,
                        userId,
                        wagerId,
                        bytes32Id
                    ).then(function () {
                        return UserStore.updateUserBets(authToken);
                    });
                }
            });
    }
    render() {
        return (
            <div>
                <Popconfirm title="Sure you want to cancel this bet?" onConfirm={this.CancelCustomWager} okText="Yes" cancelText="No">
                    <button className="custom-btn-danger">Cancel</button>
                </Popconfirm>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/layoutComponents/customWagerStages/CancelCustomWager.js